import { render, staticRenderFns } from "./EditCompany.component.vue?vue&type=template&id=56501c30"
import script from "./EditCompany.component.vue?vue&type=script&lang=ts"
export * from "./EditCompany.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports